import { useEffect, useState } from 'react';
import { Wifi, WifiOff } from 'lucide-react';
import { useTranslation } from '../utils/useTranslation';

export function OfflineIndicator() {
    const [isOnline, setIsOnline] = useState(navigator.onLine);
    const [showIndicator, setShowIndicator] = useState(false);
    const { t } = useTranslation();

    useEffect(() => {
        const handleOnline = () => {
            setIsOnline(true);
            setShowIndicator(true);

            // Esconder após 3 segundos
            setTimeout(() => setShowIndicator(false), 3000);
        };

        const handleOffline = () => {
            setIsOnline(false);
            setShowIndicator(true);
        };

        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);

        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
        };
    }, []);

    if (!showIndicator) return null;

    return (
        <div
            className={`fixed top-4 right-4 z-50 flex items-center gap-2 px-4 py-2 rounded-lg shadow-lg transition-all duration-300 ${isOnline
                    ? 'bg-green-500 text-white'
                    : 'bg-red-500 text-white'
                }`}
            style={{
                animation: 'slideIn 0.3s ease-out'
            }}
        >
            {isOnline ? (
                <>
                    <Wifi className="w-5 h-5" />
                    <span className="font-medium">{t('offline.connected')}</span>
                </>
            ) : (
                <>
                    <WifiOff className="w-5 h-5" />
                    <span className="font-medium">{t('offline.offline')}</span>
                </>
            )}
        </div>
    );
}
